import { mapGetters, mapActions } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  computed: {
    ...mapGetters({
      diningName: 'getPosSelectedDiningName',
    }),
    diningText() {
      return getMasterDataText(this.diningName, this.$t)
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
    ]),
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/diningButton.js